export default "__VITE_ASSET__6035feac__"